import { useState } from 'react'
import { ShoppingBagIcon } from "@heroicons/react/20/solid";
import ConnectDialog from "../components/ConnectDialog";

const NoDevices = ({ refreshDashboards }) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <div className="text-center mx-auto max-w-7xl sm:px-6 lg:px-8">
      <ConnectDialog open={dialogOpen} setOpen={setDialogOpen} onSuccess={refreshDashboards} />
      <h3 className="mt-2 text-sm font-semibold text-gray-900">You have no connected devices.</h3>
      <p className="mt-1 pb-4 text-sm text-gray-500">
        Click below to get started.
      </p>

      <button
        onClick={() => setDialogOpen(true)}
        type="button"
        className="relative bg-gray-100 block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-cyan-500 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
      >
        <svg
          fill="none"
          stroke="currentColor"
          viewBox="0 0 48 48"
          aria-hidden="true"
          className="mx-auto size-12 text-cyan-600"
        >
          <path
            d="M8 14v20c0 4.418 7.163 8 16 8 1.381 0 2.721-.087 4-.252M8 14c0 4.418 7.163 8 16 8s16-3.582 16-8M8 14c0-4.418 7.163-8 16-8s16 3.582 16 8m0 0v14m0-4c0 4.418-7.163 8-16 8S8 28.418 8 24m32 10v6m0 0v6m0-6h6m-6 0h-6"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="mt-2 block text-sm font-semibold text-cyan-500">
          Connect a Fungistics device
        </span>
      </button>

      <div className="mt-16">
        <div className="block text-sm font-semibold text-gray-500">Or...</div>
      </div>
      <a
        href="https://fungistics.com/"
        type="button"
        target="_blank"
        className="mt-2 inline-flex items-center rounded-md bg-cyan-800 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-cyan-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-600"
      >
        <ShoppingBagIcon aria-hidden="true" className="-ml-0.5 mr-1.5 size-5" />
        Shop the Fungistics Store
      </a>
    </div>
  );
};

export default NoDevices;
